import request from '@/utils/request'

export function fetchClientChargeList (query) {
  return request({
    url: '/card/api/client_charge/index',
    method: 'get',
    params: query
  })
}

export function createClientCharge (data) {
  return request({
    url: '/card/api/client_charge/insert',
    method: 'post',
    data
  })
}

export function updateClientCharge (data) {
  return request({
    url: '/card/api/client_charge/update',
    method: 'post',
    data
  })
}

export function deleteClientCharge (id) {
  return request({
    url: '/card/api/client_charge/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/client-charge.js